import gql from 'graphql-tag';

export const GET_PROGRAM_PARTICIPANT = gql`
  query StoreProgramParticipantAdvance(
    $pagination: PaginationInput
    $searchName: String
    $managerStoreCode: String
    $adminId: String
    $city: [String!]
    $firstSubmitDataDate: DateFilter
    $verifiedDate: DateFilter
    $lastUpdatedDate: DateFilter
    $orderBy: StoreProgramParticipantOrderBy
    $status: [StoreProgramStatus!]
    $activeTab: StoreProgramParticipantActiveTab
    $programId: String
    $programYear: String
  ) {
    storeProgramParticipantAdvance(
      pagination: $pagination
      searchName: $searchName
      managerStoreCode: $managerStoreCode
      adminId: $adminId
      city: $city
      firstSubmitDataDate: $firstSubmitDataDate
      verifiedDate: $verifiedDate
      lastUpdatedDate: $lastUpdatedDate
      orderBy: $orderBy
      status: $status
      activeTab: $activeTab
      programId: $programId
      programYear: $programYear
    ) {
      row {
        attachments {
          firstParticipantFullName
          firstParticipantIDPhoto
          firstParticipantPassport
          firstParticipantPhoneNumber
          firstParticipantPortraitPhoto
          isFirstParticipantOwner
          isSecondParticipantOwner
          ownerKK
          ownerNPWP
          ownerNPWPType
          secondParticipantFullName
          secondParticipantIDPhoto
          secondParticipantPassport
          secondParticipantPhoneNumber
          secondParticipantPortraitPhoto
        }
        preferenceCheckList {
          phoneNumber
          checklistData {
            question
            answer
            order
          }
        }
        checklistQuestions {
          order
          value
          type
          required
          notes
          guidelineAsset
          options {
            order
            value
            isOther
          }
        }
        firstSubmitDataAt
        isLastReuploadAt
        StoreProgram {
          id
          name
        }
        createdAt
        updatedAt
        confirmAt
        confirmBy
        status
        cmsParticipantStatus
        store {
          id
          cityName
          storeName
          managerStoreCode
          User {
            profile {
              idCardPhoto
              name
            }
            role
            phoneNumber
          }
        }
        admin {
          id
          name
        }
      }
      total
      totalInProgress
      totalVerified
      totalWaiting
    }
  }
`;

export const DOWNLOAD_PROGRAM_PARTICIPANT_ADVANCE = gql`
  query DownloadStoreProgramParticipantAdvance(
    $searchName: String
    $managerStoreCode: String
    $adminId: String
    $city: [String!]
    $firstSubmitDataDate: DateFilter
    $verifiedDate: DateFilter
    $lastUpdatedDate: DateFilter
    $orderBy: StoreProgramParticipantOrderBy
    $status: [StoreProgramStatus!]
    $activeTab: StoreProgramParticipantActiveTab
    $programId: String
    $programYear: String
  ) {
    downloadStoreProgramParticipantAdvance(
      searchName: $searchName
      managerStoreCode: $managerStoreCode
      adminId: $adminId
      city: $city
      firstSubmitDataDate: $firstSubmitDataDate
      verifiedDate: $verifiedDate
      lastUpdatedDate: $lastUpdatedDate
      orderBy: $orderBy
      status: $status
      activeTab: $activeTab
      programId: $programId
      programYear: $programYear
    ) {
      link
    }
  }
`;
